// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"e5f7e3ad","404":"e336ac11","787":"eec4b31a"}[chunkId] + ".chunk.js";
};